export default __webpack_public_path__ + "static/media/exit.753ef32c.svg";